import { AdmService } from 'src/app/shared/services/adm.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { AutorizacionDtoDisc } from 'src/app/shared/models/autorizacionDtoDisc';
import { AutorizacionNC } from 'src/app/shared/models/autorizacionNC';
import { AutorizacionesNCDialogComponent } from './autorizaciones-nc-dialog.component';

@Component({
  selector: 'app-autorizaciones-nc',
  templateUrl: './autorizaciones-nc.component.html'
})
export class AutorizacionesNCComponent {
  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private admService: AdmService) { }
  displayedColumns = ['acciones', 'idDivision', 'tipoNC', 'idNivel', 'cargoAutorizante', 'importe', 'noApruebaAnteriores', 'habilitacion'];
  dataSource = new MatTableDataSource<AutorizacionNC>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public Etiquetas: {
    BotonAWorkflowNC: string;
    Buscar: string,
    SinRegistros: string,
    Titulo: string,
    Headers: {
      Acciones: string,
      Habilitacion: string,
      IdNivel: string,
      Nivel: string,
      CargoAutorizante: string,
      Importe: string,
      IdDivision: string,
      NoApruebaAnteriores: string,
      TipoNC: string
    }
  }
  public Tooltips: {
    Editar: string,
    Ver: string,
    Eliminar: string
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }

  ngOnInit(): void {
    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('ADM LOCAL')) {
      this.router.navigateByUrl('');
    }
    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Ver: this.configService.tooltips.Ver,
      Eliminar: this.configService.tooltips.Eliminar
    }
    this.Etiquetas = {
      BotonAWorkflowNC: this.configService.etiquetas.AutorizacionesNC.BotonAWorkflowNC,
      Titulo: this.configService.etiquetas.AutorizacionesNC.Titulo,
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Headers: {
        Acciones: this.configService.etiquetas.Acciones,
        Habilitacion: this.configService.etiquetas.Habilitacion,
        IdNivel: this.configService.etiquetas.IdNivel,
        Nivel: this.configService.etiquetas.Nivel,
        CargoAutorizante: this.configService.etiquetas.CargoAutorizante,
        IdDivision: this.configService.etiquetas.Division,
        Importe: this.configService.etiquetas.Importe,
        TipoNC: this.configService.etiquetas.NotasCredito.TipoNC,
        NoApruebaAnteriores: this.configService.etiquetas.NoApruebaAnteriores
      }
    }
    this.buscar(0);
  }
  buscar(idTipoMensaje: number) {
    this.tablasService
      .cAutorizacionesNC(this.loggedService.logged.idPais)
      .subscribe((data: AutorizacionNC[]) => {
        this.dataSource.data = [];
        if (data.length) {

          this.dataSource.data = data;
          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  dialogAutorizaciones(idTipo: number, a: AutorizacionNC) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { a: a, idTipo: idTipo }
    let dialogRef = this.dialog.open(AutorizacionesNCDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.buscar(idTipo);
      }
    })
  }
  eliminar(a: AutorizacionNC) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación de la autorización " + a.idNivel + " - " + a.nivel + " para el cargo autorizante " + a.cargoAutorizante + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.tablasService.bAutorizacionNC(a).subscribe((data: boolean) => {

            this.buscar(3);
          })
        }
      })
  }
  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
